import React from "react";
import { Card, Collapse, TabContent } from "reactstrap";

const TabContentCard = ({ tabList, index, activeTab, tabPropertyName, children, useCollapse = true }) => {
    return (
        <TabContent style={{ border: "none" }} className="rounded-bottom" activeTab={activeTab}>
            <Collapse isOpen={useCollapse ? activeTab === tabList[index][tabPropertyName] : true}>
                <Card body style={{ margin: 0 }}>
                    {children}
                </Card>
            </Collapse>
        </TabContent>
    );
};

export default TabContentCard;
